// Layout
const dashboardLayout = () => import('@/layouts/DoctorLayout/DashboardLayout/dashboardLayout.vue')

const setting = () => import('./views/index')

// start Routes
export default [
  {
    path: '/doctor/settings',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'doctorSettings',
      meta: {
        name: 'doctorSettings',
        parentName: 'marketplace',
        userType: '',
        permission: '',
        role: 'veterinary.doctor'
      },
      component: setting
    }
    ]
  }
]
